import Icon from '../components/Icon.vue'

Icon.register({"tag":{"width":1536,"height":1792,"paths":[{"d":"M448 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1515 1024q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tag.js
// module id = 1136
// module chunks = 0